<template>
    <v-row>
        <v-col cols="12" md="9" lg="7" xl="5">    
            <v-card class="mt-n5 mx-2 px-4" outlined>
                <v-card-title>Book a Carrier Pickup</v-card-title>
                <v-card-subtitle>To view your existing pickup bookings go to the <a target="_blank" href="https://auspost.com.au/mypost-business/pickups">MyPost Business</a> web site.</v-card-subtitle>
                <v-alert type="error" v-if="carriers[selected_carrier]?.settings?.payment_method === 'PAYPAL'">Your payment method is set to PayPal so your pickups must be booked through the <a target="_blank"href="https://auspost.com.au/mypost-business/pickups">MyPost Business</a> web site.</v-alert>
                <v-alert type="error" v-if="!same_day && !next_day && attempts == 8">Currently there is no pickup service available from the address provided.</v-alert>
                <v-card class="ma-2 px-4" outlined>
                    <v-card-title>Pickup Address</v-card-title>
                    <v-row>
                        <v-col>
                            <v-text-field outlined dense hide-details clearable label="Name" v-model="pickup.from.name"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field outlined dense hide-details clearable label="Address Line 1" v-model="pickup.from.lines[0]"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field outlined dense hide-details clearable label="Address Line 2" v-model="pickup.from.lines[1]"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field outlined dense hide-details clearable label="Suburb" v-model="pickup.from.suburb" @change="address_changed"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-select
                                v-model="pickup.from.state"
                                :items="['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']"
                                :menu-props="{ bottom: true, offsetY: true }"
                                outlined dense hide-details
                                label="State"
                                 @change="address_changed"
                            >
                            </v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field outlined dense hide-details clearable label="Postcode" v-model="pickup.from.postcode" @change="address_changed"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field outlined dense hide-details clearable label="Telephone" v-model="pickup.from.phone"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card class="ma-2 px-4" outlined>
                    <v-card-title>Pickup Details</v-card-title>
                    <v-card-subtitle class="ml-n5"></v-card-subtitle>
                    <v-row>
                        <v-col>
                            <v-select
                                :items="carrier_list"
                                item-text="name"
                                item-value="id"
                                label="Select an Account"
                                outlined dense hide-details
                                v-model="selected_carrier"
                                @change="available_dates"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field outlined dense hide-details clearable label="Estimated number of parcels (max 100)" v-model="pickup.pickup_estimated_quantity"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-select
                                :items="[{val: true, text: 'No, I will not be available at pickup'}, {val: false, text: 'Yes, I will be available at pickup'}]"
                                item-text="text"
                                item-value="val"
                                label="Attended pickup?"
                                outlined dense hide-details
                                v-model="pickup.pickup_is_unattended"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field outlined dense hide-details clearable label="Pickup Instructions (optional but recommended for unattended pickups)" v-model="pickup.pickup_instructions"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col v-if="!same_day && !next_day && attempts == 8">
                            <v-alert type="error">Currently there is no pickup service available from the address provided.</v-alert>
                        </v-col>
                        <v-col v-else>
                            <v-radio-group v-model="pickup.product_id">
                                <v-card outlined class="mb-2" :disabled="!same_day">
                                    <v-card-title>Same Business Day Pickup</v-card-title>
                                    <v-card-subtitle>
                                        <v-row>
                                            <v-col>Booking cut-off time: 1pm today</v-col>
                                            <v-col>9:00am - 4:00pm</v-col>
                                            <v-col><span v-if="pickup_prices.PU1 > 0 && same_day">Cost: ${{ pickup_prices.PU1 | formatNumber(2) }}</span></v-col>
                                            <v-col>                                
                                                <v-radio value="PU1" :disabled="!same_day"></v-radio>
                                            </v-col>
                                        </v-row>
                                    </v-card-subtitle>
                                </v-card>
                                <v-card outlined>
                                    <v-card-title>Next Business Day Pickup</v-card-title>
                                    <v-card-subtitle>
                                        <v-row>
                                            <v-col>Booking cut-off time: Midnight tonight</v-col>
                                            <v-col>9:00am - 4:00pm</v-col>
                                            <v-col><span v-if="pickup_prices.PU3 > 0">Cost: ${{ pickup_prices.PU3 | formatNumber(2) }}</span></v-col>
                                            <v-col>
                                                <v-radio value="PU3"></v-radio>
                                            </v-col>
                                        </v-row>
                                    </v-card-subtitle>
                                </v-card>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-card>   
                <v-alert v-if="error" type="error" dense v-html="error"></v-alert>
                <v-alert v-if="pickup_order && !error" type="success" dense>A pickup has been successfully booked. Reference: {{ pickup_order }}. To view your booked pickups go to your <a target="_blank" href="https://auspost.com.au/mypost-business/pickups">MyPost Business account</a></v-alert>
                <v-card-actions class="pr-5 pb-5">
                    <v-spacer></v-spacer>
                    <v-btn color="indigo" class="white--text" @click="book_pickup()" :loading="loading">
                        Book Pickup
                    </v-btn>                
                </v-card-actions>
            </v-card>   
        </v-col> 
        <v-col>
            <Help codename="book_a_pickup" :hide_title="true" cols="12" sm="6" md="6" lg="12" xl="6"/>
        </v-col>  
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { getSessionToken } from '@shopify/app-bridge-utils';
import axios from 'axios'
import { errors } from '@/V2/integrations/MyPost/store/mypost_errors'
import Help from '@/V2/views/Help'

export default {
    data: function () {
		return {
            selected_carrier: null,
            current_date: new Date().toLocaleDateString('en-CA'),
            same_day: false,
            next_day: false,
            next_day_date: '',
            pickup_prices: {
                'PU1': 0,
                'PU3': 0
            },
            loading: false,
            attempts: 0,
            max_attempts: 7,
            error: '',
            standard_errors: [
                {key: "The pickup_estimated_quantity must be numeric and greater than 0.", val: "The Estimated number of parcels is invalid. It must be between 1 and 100."},
                {key: "The request is missing the mandatory field with the name lines[0].  Please resubmit the request including the required fields and values.", val: "The Address Line 1 is a required field and cannot be blank."},
                {key: "The request is missing the mandatory field with the name postcode.  Please resubmit the request including the required fields and values.", val: "The Postcode is a required field and cannot be blank."},
                {key: "The request is missing the mandatory field with the name suburb.  Please resubmit the request including the required fields and values.", val: "The Suburb is a required field and cannot be blank."},
                {key: "The request is missing the mandatory field with the name name.  Please resubmit the request including the required fields and values.", val: "The Name is a required field and cannot be blank."},
            ],
            pickup_order: null,
            pickup: {
                from: {
                    name: '',
                    lines: ['',''],
                    suburb: '',     
                    state: '',
                    postcode: '',
                    phone: '',
                },
                pickup_estimated_quantity: 0,
                pickup_is_unattended: false,
                product_id: this.same_day ? 'PU1' : 'PU3',
                pickup_date: null
            }
        }
    },
    components: {
        Help
    },
    methods: {
        getLocalDateNDaysFromToday(n) {
            const date = new Date();
            date.setDate(date.getDate() + n);
            return date.toLocaleDateString('en-CA'); // returns in YYYY-MM-DD
        },
        async address_changed() {
            this.same_day = false
            this.next_day = false
            this.next_day_date = ''
            this.attempts = 0
            this.max_attempts = 7
            this.error = ''
            await this.available_dates()
            this.pickup_cost()
        },
        async available_dates() {
            if(this.attempts <= this.max_attempts) {
                const pickup_date = this.getLocalDateNDaysFromToday(this.attempts)
                const carrier = this.carriers[this.selected_carrier]
                const token = await getSessionToken(this.$store.getters['Shopify/app']);
                const body = {
                    from: {
                        suburb: this.pickup.from.suburb,
                        state: this.pickup.from.state,
                        postcode:this.pickup.from.postcode,
                    },
                    date: pickup_date
                }

                axios.post(`${process.env.VUE_APP_V2_SHOPIFY_API}/carriers/mypost/post`, body,
                    {
                        headers: { 
                            'Authorization': token,
                            'account_number': carrier.credentials.account_number,
                            'merchant_token': carrier.credentials.merchant_token,
                            'method' : 'POST',
                            'resource': `/shipping/v1/products/pickups`
                        }
                    }
                ).then(response => {
                    if(response?.data?.body?.errors) {
                        response.data.body.errors.forEach(error => {
                            this.error = this.error + '<p>' + this.nicer_message(error.message) + '</p>'
                        })
                        this.loading = false
                        return
                    }
                    if(response?.data?.body?.products) {
                        if(response.data.body.products.some(product => product.product_id === 'PU1')) {
                            this.current_date = pickup_date
                            this.same_day = true
                        }
                        if(response.data.body.products.some(product => product.product_id === 'PU3')) {
                            this.next_day_date = pickup_date
                            this.next_day = true
                        } else {
                            this.attempts++
                            this.available_dates()
                        }
                    }
                })
            }
        },
        async pickup_cost() {
            const carrier = this.carriers[this.selected_carrier]
            const token = await getSessionToken(this.$store.getters['Shopify/app']);
            const body = {
                product_ids: ["PU3", "PU1"]
            }

            axios.post(`${process.env.VUE_APP_V2_SHOPIFY_API}/carriers/mypost/post`, body,
                {
                    headers: { 
                        'Authorization': token,
                        'account_number': carrier.credentials.account_number,
                        'merchant_token': carrier.credentials.merchant_token,
                        'method' : 'POST',
                        'resource': `/shipping/v1/prices/pickups`
                    }
                }
            ).then(response => {
                if(response?.data?.body?.prices) {
                    response.data.body.prices.forEach(price => {
                        this.pickup_prices[price.product_id] = price.total_price
                    })
                }
            })

        },
        async book_pickup() {
            this.loading = true
            this.error = ''
            const carrier = this.carriers[this.selected_carrier]
            const token = await getSessionToken(this.$store.getters['Shopify/app']);
            if(this.pickup.product_id === 'PU1') {
                this.pickup.pickup_date = this.current_date
            } else if(this.pickup.product_id === 'PU3') {
                this.pickup.pickup_date = this.next_day_date
            }

            const body = {
                pickups : [this.pickup]
            }
            axios.post(`${process.env.VUE_APP_V2_SHOPIFY_API}/carriers/mypost/post`, body,
                {
                    headers: { 
                        'Authorization': token,
                        'account_number': carrier.credentials.account_number,
                        'merchant_token': carrier.credentials.merchant_token,
                        'method' : 'POST',
                        'resource': `/shipping/v1/pickups`
                    }
                }
            ).then(response => {
                if(response?.data?.body?.pickups) {
                    this.create_order(response.data.body.pickups[0].pickup_id)
                } else {
                    response?.data?.body?.errors.forEach(error => {
                        this.error = this.error + '<p>' + this.nicer_message(error.message) + '</p>'
                    })
                    this.loading = false
                }
            })
        },
        async create_order(pickup_id) {
            const carrier = this.carriers[this.selected_carrier]
            const token = await getSessionToken(this.$store.getters['Shopify/app']);
            const body = {
                pickups:[
                    {
                        pickup_id: pickup_id,
                    }
                ],
                payment_method: this.carriers[this.selected_carrier].settings.payment_method
            }
            axios.post(`${process.env.VUE_APP_V2_SHOPIFY_API}/carriers/mypost/post`, body,
                {
                    headers: { 
                        'Authorization': token,
                        'account_number': carrier.credentials.account_number,
                        'merchant_token': carrier.credentials.merchant_token,
                        'method' : 'PUT',
                        'resource': `/shipping/v1/orders`
                    }
                }
            ).then(response => {
                if(response?.data?.body?.order) {
                    const order_id = response.data.body.order.order_id
                    if(this.carriers[this.selected_carrier].settings.payment_method === 'CHARGE_TO_ACCOUNT') {
                        const charge_body = {
                            order_id: order_id,
                            payment_method: this.carriers[this.selected_carrier].settings.payment_method,
                            attributes: {
                                'account-number': this.carriers[this.selected_carrier].settings.account_number
                            }
                        }
                        axios.post(`${process.env.VUE_APP_V2_SHOPIFY_API}/carriers/mypost/post`, charge_body,
                        {
                            headers: { 
                                'Authorization': token,
                                'account_number': carrier.credentials.account_number,
                                'merchant_token': carrier.credentials.merchant_token,
                                'method' : 'POST',
                                'resource': `/shipping/v1/payments`
                            }
                        }).then(
                            response => {
                                if(response?.data?.body?.errors) {
                                    response?.data?.body?.errors.forEach(error => {
                                        this.error = this.error + '<p>' + this.nicer_message(error.message) + '</p>'
                                    })
                                }
                                this.pickup_order = order_id
                            }
                        )

                    } else {
                        this.pickup_order = order_id
                    }
                } else {
                    response?.data?.body?.errors.forEach(error => {
                        this.error = this.error + '<p>' + this.nicer_message(error.message) + '</p>'
                    })
                }
                this.loading = false
            })

        },
        nicer_message(msg) {
            const found = this.standard_errors.find(item => item.key === msg);
            return found ? found.val : msg;
        },
        set_address() {
            const address = {...this.$store.getters['User/address']}
            this.pickup = {
                from: {
                    name: address?.name,
                    lines: [address?.address1, address?.address2 || ''],
                    suburb: address?.suburb,     
                    state: address?.state,
                    postcode: address?.postcode?.trim(),
                    phone: address?.mobile || address?.phone,
                },
                pickup_estimated_quantity: 0,
                pickup_is_unattended: false,
                product_id: this.same_day ? 'PU1' : 'PU3',
                pickup_date: null
            }
            return true
        }
    },
    mounted: async function () {
        await this.set_address()
        this.available_dates()
        this.pickup_cost()
    },
	computed : {
		...mapGetters({
			carriers: 'Carriers/carriers',
            address: 'User/address',
		}),
        carrier_list() {
            const arr = []
            Object.keys(this.carriers).forEach(c => {
                const carrier = this.carriers[c]
                if(this.$store.getters[`Carriers/${carrier.carrier}/has_pickup`]){
                    arr.push({id: carrier.carrier_id, name: carrier.name || carrier.carrier, carrier: carrier})
                }
            })
            this.selected_carrier = arr[0].id
            return arr
        },
        selected_has_pickup() {
            let has_pickup = false
            Object.keys(this.carriers).forEach(carrier => {
                if(this.$store.getters[`Carriers/${this.carriers[this.selected_carrier].carrier}/has_pickup`]){
                    has_pickup = true
                }
            })
            return has_pickup
        }
    }  
    // to be done: can we get a list of pickups using the following:
    // digitalapi.auspost.com.au/shipping/v1/orders?order_type=PICKUP&offset=0&number_of_orders=5&status=OPEN,INCOMPLETE,COMPLETED,INITIATED,IN_TRANSIT,DELIVERED,AWAITING_COLLECTION,POSSIBLE_DELAY,UNSUCCESSFUL_PICKUP,ARTICLE_DAMAGED,LOST,CANCELLED,HELD_BY_COURIER,CANNOT_BE_DELIVERED,TRACK_SHIPMENT,PAID_IN_STORE,REFUNDED,REFUND_IN_PROGRESS,PARTIALLY_REFUNDED  
}
</script>